module.exports = __webpack_public_path__ + "img/first-1-opened.32902a18.webp";